const DICTIONARY_WORD_TYPES = {
  PREPARATION_METHOD: {
    value: 'PREPARATION_METHOD',
    label: 'Preparation Method',
    fieldName: 'preparationMethods',
    shortName: 'pm',
  },
  COMMON_ENGLISH_WORD: {
    value: 'COMMON_ENGLISH_WORD',
    label: 'Common English Word',
    fieldName: 'commonEnglishWords',
    shortName: 'cew',
  },
  COMMON_FOREIGN_WORD: {
    value: 'COMMON_FOREIGN_WORD',
    label: 'Common Foreign Word',
    fieldName: 'commonForeignWords',
    shortName: 'cfw',
  },
  NAME: { value: 'NAME', label: 'Name', fieldName: 'names', shortName: 'n' },
  NOT_RELEVANT: {
    value: 'NOT_RELEVANT',
    label: 'Not Relevant',
    fieldName: 'notRelevant',
    shortName: 'nr',
  },
  WHOLE_DISH_NAME: {
    value: 'WHOLE_DISH_NAME',
    label: 'Whole Dish Name',
    fieldName: 'wholeDishNames',
    shortName: 'wdn',
  },
  AMBIGUOUS: {
    value: 'AMBIGUOUS',
    label: 'Ambiguous',
    fieldName: 'ambigous',
    shortName: 'a',
  },
  CONFLICTING_LABEL: {
    value: 'CONFLICTING_LABEL',
    label: 'Conflicting Label',
    fieldName: 'conflictingLabels',
    shortName: 'cl',
  },
  INGREDIENT_MEASUREMENT: {
    value: 'INGREDIENT_MEASUREMENT',
    label: 'Ingredient Measurements',
    fieldName: 'ingredientMeasurements',
    shortName: 'im',
  },
}

export default DICTIONARY_WORD_TYPES
